import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IModalOptions } from '../../../gamma/modal';
import { ToastService } from '../../../gamma/toast';

import { LogicalUnitModalBaseComponent } from '../../../gamma/logicalunit';
import { ModalDismissGuard } from '../../../gamma/modal/modal-dismiss.guard';
import { RoutingService } from '../../../gamma/routing';
import { U2026_NetPromoterScoreService } from '../U2026_netpromoterscore.service';

export type U2026_NetPromoterScoreContext = 'ElectronicCheque' | 'PortalPayer';

export interface IU2026_NetPromoterScoreModalContext {
    userContext: U2026_NetPromoterScoreContext;
}

@Component({
    selector: 'u2000-netpromoterscore-modal',
    templateUrl: 'U2026_netpromoterscore-modal.component.html',
    styleUrls: ['U2026_netpromoterscore-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2026_NetPromoterScoreModalComponent extends LogicalUnitModalBaseComponent<U2026_NetPromoterScoreService, boolean> implements OnInit {
    // Read by U2000_ModalProvider before the modal is created (size/backdrop can no longer be
    // mutated from this component's own constructor under ngx-bootstrap — see U2000_modal.provider.ts).
    static readonly modalDisplayOptions: IModalOptions = { backdrop: true, dialogClass: 'modal-dialog u2026_netpromoterscore-modal' };

    // Populated by ngx-bootstrap from ModalOptions.initialState.context — see
    // U2000_ModalProvider.openComponent.
    context: IU2026_NetPromoterScoreModalContext;

    userContext: U2026_NetPromoterScoreContext;

    constructor(
        service: U2026_NetPromoterScoreService,
        // ModalComponent requirements
        public dialog: BsModalRef,
        // Super requirements
        toastService: ToastService,
        routingService: RoutingService,
        modalDismissGuard: ModalDismissGuard,
    ) {
        super(service, dialog, toastService, routingService, modalDismissGuard);
    }

    override ngOnInit() {
        super.ngOnInit();
        this.userContext = this.context.userContext;
    }

    onComplete() {
        this.result = true;
        this.dialog.hide();
    }

    closeClick() {
        this.service.skipSurvey().subscribe(
            res => {
                this.result = false;
                this.dialog.hide();
            },
            err => {
                this.result = false;
                this.dialog.hide();
            },
        );
    }

    onCancel() {
        this.closeClick();
    }
}
